import React, { FunctionComponent } from "react";
import {
  flexBenefitsMemberPortalText,
  flexBenefitsMemberSiteText,
} from "../../core/constants/strings";
import {
  flexBenefitsMemberPortalUrl,
  flexBenefitsMemberSiteUrl,
} from "../../core/constants/endpoints";

interface FlexBenefitsTpaLinksProps {
  idPrefix: string;
}

/**
 * The two FlexBenefits TPA outbound links, shared by FlexBenefitsSupport (Slice 1)
 * and FlexBenefitsDocumentGroup (Slice 3) so the destinations/copy live in one place.
 */
const FlexBenefitsTpaLinks: FunctionComponent<FlexBenefitsTpaLinksProps> = ({
  idPrefix,
}) => (
  <>
    <a
      id={`${idPrefix}-member-site`}
      href={flexBenefitsMemberSiteUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="mr-3"
    >
      {flexBenefitsMemberSiteText}
    </a>
    <a
      id={`${idPrefix}-member-portal`}
      href={flexBenefitsMemberPortalUrl}
      target="_blank"
      rel="noopener noreferrer"
    >
      {flexBenefitsMemberPortalText}
    </a>
  </>
);

export default FlexBenefitsTpaLinks;
